<template>
  <expandable header="Informant Details" class="mb-10">
    <b-row>
      <b-col cols="12" md="4">
        <input-field
          v-model.trim="form.informant_name"
          label="Name of Informant"
          :disabled="isDisabled"
          @input="onInput"
          rules="max-150"
        ></input-field>
      </b-col>
      <b-col cols="12" md="4">
        <input-field
          v-model.trim="form.informant_designation"
          label="Designation"
          :disabled="isDisabled"
          @input="onInput"
          rules="max-100"
        ></input-field>
      </b-col>
      <b-col cols="12" md="4">
        <input-field
          v-model.trim="form.informant_phone"
          label="Phone Number"
          type="number"
          :disabled="isDisabled"
          @input="onInput"
          rules="integer"
        ></input-field>
      </b-col>
      <b-col cols="12" md="4">
        <date-time-picker
          v-model="form.information_datetime"
          label="Date & Time of Information"
          :disabled="isDisabled"
          @input="onInput"
        ></date-time-picker>
      </b-col>
    </b-row>
  </expandable>
</template>

<script>
import Expandable from "../../Expandable.vue";
import InputField from "../../form/InputField.vue";
import DateTimePicker from "../../form/DateTimePicker.vue";

export default {
  components: { Expandable, InputField, DateTimePicker },
  props: {
    value: {},
    isDisabled: { default: false, type: Boolean },
  },
  data() {
    return { form: {} };
  },
  methods: {
    onInput() {
      this.$emit("input", this.form);
    },
  },
  beforeMount() {
    this.form = this.value;
  },
  mounted() {
    this.onInput();
  },
};
</script>
